<template>
	<nav class="school-navbar">
		<div class="nav-container">
			<div class="hstack gap-3 text-white me-auto" data-v-step="2">
				<figure
					class="logo d-none d-sm-flex align-items-center m-0 me-3"
					alt="PTC Wizard Logo"
				>
					<Logo class="h-100" />
				</figure>
			</div>

			<div class="nav-right">
				<div style="width: 150px"></div>
				<button class="help fs-6">
					<i class="bi fs-5 bi-question-circle"></i>
					<RouterLink
						style="text-decoration: none; color: unset"
						:to="{ name: 'school-help' }"
						data-cy="nav-school-help-btn"
					>
						<span class="d-none d-sm-block">Help</span>
					</RouterLink>
				</button>
                <div class="dropdown" data-cy="nav-select">
					<button
						class="btn text-white dropdown-toggle text-capitalize fs-normal px-2"
						type="button"
						id="dropdownMenuButton1"
						data-bs-toggle="dropdown"
						aria-expanded="false"
                        data-cy="nav-dropdown-btn"
					>
						<i class="bi bi-person-fill fs-4 me-n1 d-md-none"></i>
						<span class="d-none d-md-inline-block align-middle">
							{{ schoolStore.school?.school_name }}
							<template v-if="districtSchoolName"> - {{ districtSchoolName }} </template>
						</span>
					</button>
					<ul
						class="dropdown-menu dropdown-menu-end"
						aria-labelledby="dropdownMenuButton1"
					>
						<li style="cursor: pointer">
							<RouterLink
								style="text-decoration: none; color: unset"
								:to="{ name: 'school-settings' }"
								data-cy="nav-account-settings-btn"
							>
								<span class="dropdown-item" @click="authenticationStore.modal = true"
									>Account Settings</span
								>
							</RouterLink>
						</li>
                        <li style="cursor: pointer">
                            <span class="dropdown-item" @click="logout()" data-cy="nav-logout-btn">Log Out</span>
						</li>
						<template
							v-if="
								schoolStore.school?.is_district === 'yes' ||
								schoolStore.school?.is_district === true
							"
						>
							<li><hr class="dropdown-divider" /></li>
							<li><span class="dropdown-header">Schools</span></li>
							<li
								style="cursor: pointer"
								v-for="school in districtStore.schools"
								:key="school.school_id"
							>
								<label
									style="cursor: pointer"
									:for="`school_${school.school_id}`"
									class="dropdown-item d-flex gap-2 align-center"
								>
									<input
										:id="`school_${school.school_id}`"
										type="radio"
										:value="school.school_id"
										name="school"
										:checked="schoolStore.school_id === school.school_id"
										@change="schoolStore.school_id = school.school_id"
									/>{{ school.school_name }}</label
								>
							</li>
						</template>
					</ul>
				</div>
			</div>
		</div>
	</nav>
</template>
<script lang="ts" setup>
import { onMounted } from "vue";

import { useAuthenticationStore } from "@/stores/authentication";
import { useRoute } from "vue-router";
import { useSchoolStore } from "@/stores/school";
import Logo from "@/assets/icons/logo-vertical-knockout.svg";
import { useDistrictStore } from "@/stores/district";
import { watch } from "vue";
import { computed } from "vue";

// defineProps<{}>();
// defineEmits();

const route = useRoute();
const authenticationStore = useAuthenticationStore();
const schoolStore = useSchoolStore();
const districtStore = useDistrictStore();

function logout() {
	authenticationStore.logout();
	window.location.pathname = "/" + route.params.account + "/school/login";
}
onMounted(() => {
	try {
		// if (!authenticationStore.me.uid) {
		//   authenticationStore.fetchProfile();
		// }
		if (schoolStore.school == null) {
			schoolStore.loadSchool().then(() => {
				console.log("got school data again");
			});
		}
		if (districtStore.schools == null || districtStore.schools.length === 0) {
			console.log("fetching schools for district");
			districtStore.fetchSchools();
		}
	} catch (e) {
		console.log(e);
	}

	watch(
		() => districtStore.schools,
		() => {
			if (!schoolStore.school_id)
				schoolStore.school_id = districtStore.schools[0]?.school_id || 0;
		}
	);
});

const districtSchoolName = computed(() => {
	if (authenticationStore.jwtData.authentication_type === "district") {
		const school = districtStore.schools?.find(
			(s) => s.school_id === schoolStore.school_id
		);
		if (school) return school.school_name;
	}
	return null;
});
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.school-navbar {
	padding: 10px 15px;
	display: flex;
	background: linear-gradient(#4c1216, #721a1e 20%, #4b1216);

	.nav-container {
		display: flex;
		justify-content: space-between;
		width: 100%;

		.select-event {
			height: fit-content;
			display: flex;
			align-items: flex-start;
			justify-content: center;
			flex-direction: column;
			button {
				margin: 0;
				padding: 0;
			}
		}

		.nav-right {
			display: flex;
			align-items: center;
			gap: 20px;

			:deep(.v-select__selection-text) {
				color: white;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.help {
				display: flex;
				align-items: center;
				gap: 7px;
				color: white;
				padding: 5px 10px;
				border-radius: 4px;
				transition: background-color 0.2s linear;

				&:hover {
					background-color: rgba(0, 0, 0, 0.134);
				}
				&:active {
					background-color: rgba(0, 0, 0, 0.234);
				}
			}
		}
	}
}
</style>
